var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtopicVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 27.9922C22.4321 27.9922 27.8047 22.6196 27.8047 15.9922C27.8047 9.36477 22.4321 3.99219 15.8047 3.99219C9.17727 3.99219 3.80469 9.36477 3.80469 15.9922C3.80469 22.6196 9.17727 27.9922 15.8047 27.9922Z",
    fill: "url(#paint0_linear_3963_7444)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.218 16.7924L13.7532 20.9921C13.1196 21.3481 12.3066 20.917 12.3066 20.1993V11.7999C12.3066 11.0832 13.1185 10.651 13.7532 11.0082L21.218 15.2079C21.3621 15.2876 21.4819 15.4029 21.5652 15.5421C21.6485 15.6812 21.6924 15.8392 21.6924 16.0001C21.6924 16.161 21.6485 16.3191 21.5652 16.4582C21.4819 16.5973 21.3621 16.7126 21.218 16.7924Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3963_7444",
    x1: 15.8047,
    y1: 3.99219,
    x2: 15.8047,
    y2: 27.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtopicVideoIcon);
export default __webpack_public_path__ + "static/media/subtopic-video-icon.1a8d2f5257c1921415ce34e9155592e7.svg";
export { ForwardRef as ReactComponent };